export default {
	page_title: 'Расписание',
	day: 'День {number}',
	'table.activity': 'Интерактив',
	'table.period': 'Период проведения',
	'table.description': 'Призы и информация',
};
